import { useUserStore } from '@/stores/user'

export const PUSH_NOTIFICATIONS_POPUP_KEY = 'PREVENT_NOTIFICATIONS_POPUP'
export const PUSH_NOTIFICATIONS_ACTIVE_KEY = 'PREVENT_NOTIFICATIONS_ACTIVE'

const _LOCAL_STORAGE_KEYS = [PUSH_NOTIFICATIONS_POPUP_KEY, PUSH_NOTIFICATIONS_ACTIVE_KEY] as const

type LocalStorageKey = (typeof _LOCAL_STORAGE_KEYS)[number]

function useLocalStoragePerUser() {
  const { user } = useUserStore()

  function getUsersByKey(key: LocalStorageKey): string[] {
    return JSON.parse(localStorage.getItem(key) || '[]')
  }

  function saveUsersByKey(key: LocalStorageKey, users: string[]) {
    localStorage.setItem(key, JSON.stringify(users))
  }

  function addUserToLocalStorageByKey(key: LocalStorageKey) {
    const userName = user?.userName
    const currentUsers = getUsersByKey(key)

    if (userName && !currentUsers.includes(userName)) {
      saveUsersByKey(key, [...currentUsers, userName])
    }
  }

  function removeUserFromLocalStorageByKey(key: LocalStorageKey) {
    const userName = user?.userName
    const currentUsers = getUsersByKey(key)

    saveUsersByKey(
      key,
      currentUsers.filter((name) => name !== userName)
    )
  }

  return {
    addUserToLocalStorageByKey,
    removeUserFromLocalStorageByKey,
    getUsersByKey
  }
}

export default useLocalStoragePerUser
